// @flow
export { default } from './PlainTemplate';



// WEBPACK FOOTER //
// ./src/components/common/PlainTemplate/index.js